import { versionSchema } from "./version.schema";

export class VersionComparator {
  /**
   * current >= required 인지 비교하는 메소드
   */
  static isGreaterThanOrEqual(current: string, required: string): boolean {
    const currentParts = this.parseVersion(current);
    const requiredParts = this.parseVersion(required);

    const maxLength = Math.max(currentParts.length, requiredParts.length);

    for (let i = 0; i < maxLength; i++) {
      const currentPart = currentParts[i] || 0;
      const requiredPart = requiredParts[i] || 0;

      if (currentPart > requiredPart) {
        return true;
      } else if (currentPart < requiredPart) {
        return false;
      }
    }

    return true; // 모든 부분이 같으면 true
  }

  /**
   * current > required 인지 비교하는 메소드
   */
  static isGreaterThan(current: string, required: string): boolean {
    const currentParts = this.parseVersion(current);
    const requiredParts = this.parseVersion(required);

    const maxLength = Math.max(currentParts.length, requiredParts.length);

    for (let i = 0; i < maxLength; i++) {
      const currentPart = currentParts[i] || 0;
      const requiredPart = requiredParts[i] || 0;

      if (currentPart > requiredPart) {
        return true;
      } else if (currentPart < requiredPart) {
        return false;
      }
    }

    return false; // 모든 부분이 같으면 false
  }

  private static parseVersion(version: string): number[] {
    return versionSchema.parse(version).split(".").map(Number);
  }
}
